"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var ShieldCheck = function ShieldCheck(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 40 40",
    width: "40",
    height: "40"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22,3.775c0.005-0.603-0.343-1.152-0.89-1.406C18.24,1.108,15.135,0.471,12,0.5C8.865,0.471,5.76,1.108,2.89,2.369 C2.343,2.623,1.995,3.172,2,3.775v7.637C1.992,16.484,5.101,21.04,9.828,22.88l1.067,0.414c0.711,0.275,1.499,0.275,2.21,0 l1.067-0.414c4.727-1.84,7.836-6.396,7.828-11.468V3.775z M18.508,8.239l-6.035,8.232c-0.216,0.294-0.549,0.479-0.912,0.507 c-0.033,0-0.065,0-0.1,0c-0.332,0-0.65-0.132-0.884-0.367L6,12.036c-0.479-0.497-0.465-1.288,0.031-1.767 c0.485-0.468,1.253-0.468,1.737,0l3.341,3.342c0.097,0.098,0.256,0.098,0.354,0.001c0.009-0.009,0.018-0.019,0.025-0.03l5-6.821 c0.4-0.562,1.181-0.694,1.743-0.294c0.562,0.4,0.694,1.181,0.294,1.743c-0.007,0.01-0.014,0.019-0.021,0.029L18.508,8.239z",
    stroke: "none",
    fill: fill,
    strokeWidth: "0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
ShieldCheck.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
ShieldCheck.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = ShieldCheck;